import objectAssign from 'object-assign';

export function notifications( state = { 
	stored: [],
	visible: [],
	fetching: false
}, action ) {

	switch( action.type ) {

		case 'REQUEST_NOTIFICATION':
			return Object.assign({}, state, {
				fetching: true
			})

		case 'RECEIVE_NOTIFICATION':
			var newData = { 
				stored: state.stored,
				fetching: false
			};
			for (var a = 0; a <= newData.stored.length - 1; a++) {
				if( newData.stored[a].ID == action.notification.ID ) {
					newData.stored[a].seen 		= action.notification.seen;
					newData.stored[a].seen_date 	= action.notification.seen_date;
					break;
				}
			}
			return Object.assign({}, state, newData)

		case 'REQUEST_NOTIFICATIONS':
			return Object.assign({}, state, {
				fetching: true
			})

		case 'RECEIVE_NOTIFICATIONS':
			return Object.assign({}, state, {
				stored: action.notifications,
				fetching: false
			})

		case 'REQUEST_NEW_NOTIFICATIONS':
			return Object.assign({}, state, {
				fetching: true
			})

		case 'RECEIVE_NEW_NOTIFICATIONS':
			var newData = { 
				stored: state.stored,
				fetching: false
			};
			return Object.assign({}, state, {
				stored: action.notifications.concat(newData.stored),
				fetching: false
			})

		case 'RECEIVE_VISIBLE_NOTIFICATION':
			if(!action.notification) return state;
			var current = state.visible;
			current.unshift(action.notification)
			return Object.assign({}, state, {
				visible: current
			})

		default:
			return state;

	}

}



// WEBPACK FOOTER //
// ./src/js/reducers/notifications.js